import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import GradeRiskCriteriaForm from 'components/organisms/forms/GradeRiskCriteriaForm'

import { crudActionsMap } from 'utils/helpers'

const GradeRiskCriteriaCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('risk.grade-risk-criteria')} / ${t('common.' + action)}`} />
      <PageBody>
        <GradeRiskCriteriaForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default GradeRiskCriteriaCrudPage
